import Jwt from '../helper/interceptors';
import { AppSettings } from '../constants';
import { MapResponse } from '../helper/helper-api';


export const getArticlesCategories = () => {
  return Jwt(AppSettings.CURRENT_SITE_URI, true)
    .get('/api/v2/homeowner/account/articles-categories')
    .then(response => { return MapResponse(response); })
    .catch(error => { return MapResponse(error.response); });
};

export const getArticlesList = (params) => {
  return Jwt(AppSettings.CURRENT_SITE_URI, true)
    .get(`/api/v2/homeowner/account/articles-list/${params.id}`)
    .then(response => { return MapResponse(response); })
    .catch(error => { return MapResponse(error.response); });
};



// WEBPACK FOOTER //
// ./src/HomeCare/api.js